import util from '@/utils/util'
import request from '@/utils/request'


//shop类别

/**
 * 获取商品总类别
 * @param {*} params 
 * @returns 
 */
export function fetchShopMenus(category) {
    return request({
        url: '/ShopCategory/TreeData?v=' + util.getVersion(),
        params: {},
        method: 'get'
    }).then((res) => {
        return res.data;
    });
}
/**
 * 获取类别信息
 * @param {*} params 
 * @returns 
 */
export function fetchShopMenuDetail(id) {
    return request({
        url: '/ShopCategory/' + id,
        method: 'get'
    });
}
/**
 * 获取类别信息
 * @param {*} params 
 * @returns 
 */
export function fetchShopProductCode(id) {
    return request({
        url: '/ShopProduct/Generatecode?preChar=',
        method: 'get'
    });
}
/**
 * 修改提交商品类别
 * @param {*} params 
 * @returns 
 */
export function submitShopMenu(data) {
    return request({
        url: '/ShopCategory/' + (data.id || ''),
        method: data.id ? 'put' : 'post',
        data: data
    });
}
/**
 * 删除商品类别
 * @param {*} params 
 * @returns 
 */
export function delShopMenu(dataID) {
    return request({
        url: '/ShopCategory/' + (dataID || ''),
        method: 'delete'
    });
}


//shop商品管理

/**
 * 获取shop商品列表
 * @param {*} params 
 */
export function fetchShopDetail(id) {
    return request({
        url: '/ShopProduct/' + id,
        method: 'get'
    });
}

export function fetchShopList(params) {
    return request({
        url: '/ShopProduct/Search',
        method: 'post',
        data: params
    });
}

export function addproduct(params) {
    return request({
        url: '/ShopProduct/Insert',
        method: 'post',
        data: params
    });
}


export function delShopFile(id) {
    return request({
        url: '/ShopProduct/DelFile/' + id,
        method: 'delete'
    });
}

/**
 * 修改shop商品信息
 * @param {*} params 
 * @returns 
 */
export function submitShopinfo(id, params) {
    return request({
        url: '/ShopProduct/Modify/' + id,
        method: 'put',
        data: params
    });
}

/**
 * 添加shop商品信息
 * @param {*} params 
 * @returns 
 */
export function addShopinfo(params) {
    return request({
        url: '/ShopProduct',
        method: 'post',
        data: params
    });
}

export function delShopinfo(id) {
    return request({
        url: '/ShopProduct/' + id,
        method: 'delete'
    });
}

export function fetchShopCode(code) {
    return request({
        url: '/ShopProduct/GetDto/' + (code || ""),
        method: 'get'
    });
}


export function fetchShopImageList(productCode) {
    return request({
        url: '/ShopProduct/ImageList/' + productCode,
        method: 'get'
    });
}

export function deleteShopImage(id) {
    return request({
        url: '/BaseUploader/' + id,
        method: 'delete'
    });
}

//小程序订单管理
export function fetchShopOrderDetail(id) {
    return request({
        url: '/ShopOrder/' + id,
        method: 'get'
    });
}

export function fetchShopOrderdelete(id) {
    return request({
        url: '/ShopOrder/'+ id ,
        method: 'delete'
    });
}

export function fetchShopOrderList(params) {
    return request({
        url: '/ShopOrder/Search',
        method: 'post',
        data: params
    });
}

export function fetchShopOrderDto(orderNo) {
    return request({
        url: '/ShopOrder/GetDto/' + orderNo,
        method: 'get'
    });
}


//小程序会员管理
export function fetchShopuser(params) {
    return request({
        url: '/ShopUser/Search',
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        data: params
    });
}

export function exportShopuser(params) {
    return request({
      url: '/ShopUser/Export',
      method: 'post',
      headers: {
        'Content-Type': 'application/json'
      },
      data: params
    });
}

export function fixShopuser(id, data) {
    return request({
      url: '/ShopUser/' + id,
      method: 'put',
      headers: {
        'Content-Type': 'application/json'
      },
      data: data
    });
}

export function delShopuser(id) {
  return request({
    url: '/ShopUser/' + id,
    method: 'delete'  // 修改为delete方法
  });
}

export function exportShopOrderDetail(params) {
  return request({
    url: '/ShopOrder/ExportDetail',
    method: 'post',
    data: params
  });
}

//小程序退款管理
export function fetchShopRefundList(params) {
  return request({
    url: '/ShopRefund/Search',
    method: 'post',
    data: params
  });
}

export function fetchShopRefundDetail(refundNo) {
  return request({
    url: '/ShopRefund/GetDto/' + refundNo,
    method: 'get'
  });
}

export function auditShopRefund(refundNo, status, remark) {
  return request({
    url: '/ShopRefund/Audit/' + refundNo,
    method: 'post',
    params: {
      status: status,
      remark: remark
    }
  });
}

export function exportShopRefundDetail(params) {
  return request({
    url: '/ShopRefund/ExportDetail',
    method: 'post',
    data: params
  });
}

export function delShopRefund(id) {
  return request({
    url: '/ShopRefund/' + id,
    method: 'delete'
  });
}
